import { Link } from "react-router-dom";
import { Check, Truck, Trash2, Sparkles, ArrowRight, MessageCircle } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "@/components/site/Reveal";
import { WHY_CHOOSE } from "@/data/content";
import { whatsappLink } from "@/config/site";
import { track } from "@/lib/analytics";

export const WhyChoose = () => (
  <section className="bg-emerald-50 py-20 sm:py-28" data-testid="why-choose-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-sm font-bold uppercase tracking-widest text-emerald-700">The difference</p>
        <h2 className="mt-3 max-w-2xl font-display text-4xl font-black tracking-tight text-emerald-950 sm:text-5xl">
          Why Choose GoCleaning Dublin?
        </h2>
      </Reveal>
      <Stagger className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {WHY_CHOOSE.map((point) => (
          <StaggerItem key={point}>
            <div className="flex h-full items-start gap-3 rounded-2xl bg-white p-5 shadow-[0_8px_30px_rgb(0,0,0,0.04)]" data-testid="why-item">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-emerald-700 text-white"><Check size={15} /></span>
              <span className="font-semibold text-emerald-950">{point}</span>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);

const BUNDLE = [
  { icon: Sparkles, title: "End-of-Tenancy Cleaning" },
  { icon: Truck, title: "Furniture Transport & Moving" },
  { icon: Trash2, title: "Rubbish & Unwanted-Item Removal" },
];

export const Combined = () => (
  <section className="bg-white py-20 sm:py-28" data-testid="combined-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="overflow-hidden rounded-[2rem] bg-slate-950 p-8 text-white sm:p-12 lg:p-16">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <Reveal>
            <span className="inline-flex items-center gap-2 rounded-full bg-emerald-600/20 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-emerald-300">Bundle & save</span>
            <h2 className="mt-4 font-display text-4xl font-black tracking-tight sm:text-5xl">Cleaning, Moving and Rubbish Removal</h2>
            <p className="mt-4 text-slate-300">
              Moving out often involves more than cleaning. Request cleaning together with furniture
              transport, unwanted-item removal or a full moving service. Each service is priced
              separately, and a combined quote can be provided after receiving photos and property details.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link to="/contact" data-testid="combined-quote-btn" className="group inline-flex items-center justify-center gap-2 rounded-full bg-emerald-600 px-7 py-4 text-base font-bold text-white transition-all hover:bg-emerald-500">
                Request a Combined Quote <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
              </Link>
              <a href={whatsappLink()} onClick={() => track.whatsappClick("combined")} target="_blank" rel="noreferrer" data-testid="combined-whatsapp-btn"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-7 py-4 text-base font-bold text-white transition-transform hover:scale-105">
                <MessageCircle size={18} /> WhatsApp Us
              </a>
            </div>
          </Reveal>
          <Stagger className="grid gap-4">
            {BUNDLE.map((b) => (
              <StaggerItem key={b.title}>
                <div className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/5 p-5">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-600 text-white"><b.icon size={22} /></span>
                  <span className="font-display text-lg font-bold">{b.title}</span>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </div>
    </div>
  </section>
);
